<template>
  <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
    <div v-for="(pair, index) in item.marks" :key="index">
      <div style="display: flex; justify-content: space-between; padding-top: 10px; padding-bottom: 10px">
        <v-row no-gutters>
          <v-col cols="12" lg="6"> {{ pair.name }} </v-col>
          <v-col cols="12" lg="6" style="text-align: right;">
            <div v-if="item.hasGrade">
              <strong :style="{ color: pair.reviewChanged ? 'red' : 'inherit' }">
                {{ convertValue(pair) }}
              </strong>
            </div>
            <div v-else>
              <strong>
                Chưa có
              </strong>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-divider v-if="index < item.marks.length - 1"></v-divider>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    item: Object
  },
  methods: {
    convertValue(mark) {
      const statusMapping = {
        present: 'Có thi',
        absent: 'Vắng thi',
        suspended: 'VPQC'
      }
      const result =
        mark.status === 'present' ? (mark.value ? mark.value : 'Chưa có kết quả') : statusMapping[mark.status]
      return result
    }
  },
  filters: {
    getDate: item => {
      if (item) {
        return moment(item)
          .utcOffset(0)
          .format('DD/MM/YYYY, [lúc] HH:mm')
      }
      return 'Chưa có thông tin'
    }
  }
}
</script>
